declare namespace $ {

	type $shm_ba_summary_card__title_shm_ba_summary_1 = $mol_type_enforce<
		ReturnType< $shm_ba_summary['card_title'] >
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_ba_summary_2 = $mol_type_enforce<
		ReturnType< $shm_ba_summary['card_value'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__selected_shm_ba_summary_3 = $mol_type_enforce<
		ReturnType< $shm_ba_summary['card_selected'] >
		,
		ReturnType< $shm_ba_summary_card['selected'] >
	>
	type $shm_ba_summary_card__click_shm_ba_summary_4 = $mol_type_enforce<
		ReturnType< $shm_ba_summary['pick'] >
		,
		ReturnType< $shm_ba_summary_card['click'] >
	>
	export class $shm_ba_summary extends $mol_view {
		cards( ): readonly(any)[]
		card_title( id: any): string
		card_value( id: any): string
		card_selected( id: any): boolean
		pick( id: any, next?: any ): any
		table( ): any
		selected( next?: string ): string
		sub( ): ReturnType< $shm_ba_summary['cards'] >
		Card( id: any): $shm_ba_summary_card
	}
	
}

//# sourceMappingURL=summary.view.tree.d.ts.map